<template>
  <footer class="main-footer" v-if="$root.dataReady && footerReady">
    <div v-if="!this.$root.smallFooter" class="container">
      <div class="content">
        <div class="row no-margin new-footer">
          <div class="col-l-12 col-m-12 col-s-12">
            <div class="title">{{ footer.general_enquiries.title }}</div>
            <div class="row no-margin"></div>
          </div>

          <div
            :class="[
              footer.general_enquiries.elements.length == 2
                ? 'col-l-4 col-m-4'
                : 'col-l-3 col-m-3',
              'col-s-12 contact',
            ]"
            :key="i"
            v-for="(element, i) in footer.general_enquiries.elements"
          >
            <div class="box box--white">
              <div class="title">{{ element.title }}</div>
              <p class="name">{{ element.name }}</p>
              <p class="footer-email">
                <a :href="['mailto:' + element.email]">{{ element.email }}</a>
              </p>
              <p class="number">
                <a :href="['tel:' + element.number]">{{ element.number }}</a>
              </p>
            </div>
          </div>

          <div
            v-if="footer.crisis_support.title"
            :class="[
              footer.general_enquiries.elements.length == 2
                ? 'col-l-4 col-m-4'
                : 'col-l-3 col-m-3',
              'col-s-12 crisis-contact',
            ]"
          >
            <div class="box">
              <div class="title">{{ footer.crisis_support.title }}</div>
              <p>{{ footer.crisis_support.text }}</p>
              <p class="footer-email">
                <a
                  class="footer-email"
                  v-if="footer.crisis_support.email"
                  :href="['mailto:' + footer.crisis_support.email]"
                  >{{ footer.crisis_support.email }}</a
                >
              </p>
              <p v-if="footer.crisis_support.number">
                <a :href="['tel:' + footer.crisis_support.number]">{{
                  footer.crisis_support.number
                }}</a>
              </p>
              <p v-if="footer.crisis_support.number2">
                <a :href="['tel:' + footer.crisis_support.number2]">{{
                  footer.crisis_support.number2
                }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="row no-margin new-footer">
          <div class="col-l-12 col-m-12 col-s-12">
            <div class="socials">
              <span class="social-container">
                <a
                  :key="i"
                  :href="social.link"
                  target="_blank"
                  class="icon"
                  v-for="(social, i) in footer.socials"
                  v-html="social.icon"
                ></a>
              </span>
            </div>
          </div>
        </div>
        <div class="row no-margin new-footer">
          <div class="col-l-5 col-m-5 col-s-12 order-s-2">
            <div class="footer-text footer-copyright">
              <ul>
                <li>{{ footer.copyright }}</li>
                <li>
                  <a
                    class="modern-slavery pl-10"
                    :href="footer.modern_slavery_statement"
                  >
                    {{ footer.modern_slavery_statement_label }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="col-l-7 col-m-7 col-s-12 order-s-1">
            <div class="footer-text">
              <ul>
                <li
                  v-for="(menu, index) in menus"
                  :key="index"
                  active-class="active"
                >
                  <a :href="menu.url">{{ menu.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "main-footer",
  data() {
    return {
      footer: null,
      footerReady: false,
    };
  },
  mounted: function () {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/page_components?slug=footer",
        function (response) {
          self.footer = response[0].acf;
        }
      )
        .done(function () {
          $.get(
            self.$root.apiUrl + "wp-json/menus/v1/menus/footer",
            function (response) {
              self.menus = response.items;
              self.footerReady = true;
            }
          )
            .done(function () {})
            .fail(function () {});
        })
        .fail(function () {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// MainFooter.vue?320312a3